import { useTranslation } from "react-i18next";

import AboutUsCardLeft from "../../components/AboutUsCardLeft/AboutUsCardLeft";
import AboutUsCardRight from "../../components/AboutUsCardRight/AboutUsCardRight";

import "./AboutUs.css";

const AboutUs = () => {
	const { t } = useTranslation();
	const items = t("team.full.items", { returnObjects: true });

	return (
		<div className="about-us-bg">
			<h1 className="about-us-title">
				{t("team.full.title")} <br /> {t("team.full.title2")}
			</h1>
			<h2 className="about-us-subtitle">{t("team.full.subtitle")}</h2>
			{items.map((item, index) => {
				return item["imagePosition"] === "left" ? (
					<AboutUsCardLeft
						key={index}
						data={{
							id: index,
							image: item["image"],
							alt: item["alt"],
							texts: item["texts"],
						}}
					/>
				) : (
					<AboutUsCardRight
						key={index}
						data={{
							id: index,
							image: item["image"],
							alt: item["alt"],
							texts: item["texts"],
						}}
					/>
				);
			})}
		</div>
	);
};

export default AboutUs;
